export { default as ConsentCheckbox } from './ConsentCheckbox';
